<template>
  <div class="homepage u-full-width u-overflow-x-hidden">
    <app-header :platforms="platforms" />
    <strate-video />
    <strate-keypoints />
    <strate-themes v-if="!$device.isMobile && !$device.isTablet"/>
    <strate-themes-mobile v-if="$device.isMobile || $device.isTablet"/>
    <strate-video-2 />
    <div class="u-bg-black u-pad-y-lg">
      <anim-scroll class="u-row u-center">
        <div class="u-w2of12 u-w4of12--sm u-w6of12--xs">
          <img class="u-block u-full-width" alt="ministere" src="/images/ministere.png">
        </div>
      </anim-scroll>
      <div class="u-row u-center u-marg-t-lg t-text">
        <anim-scroll :isStagger="true" class="u-w3of12 u-left u-center--sm u-w10of12--sm">
          {{ $t('prod.text1') }}
        </anim-scroll>
        <anim-scroll :isStagger="true" class="u-w3of12 u-marg-l-1of12 u-center--sm u-left u-marg-l-0--sm u-marg-t-md--sm u-w10of12--sm">
          <div>
            {{ $t('prod.text2') }}
          </div>
          <div>
            <external-link :href="$i18n.locale === 'fr' ? 'https://drive.google.com/file/d/1BlH7oGBAgxQ1XWJwJlG8QSZoWsU1AkKV/view' : 'https://drive.google.com/file/d/124ktLVN6mPEweH2Kkg0y672pRtKwOTDf/view'" target="_blank" class="t-regular">{{ $t('prod.link') }}</external-link>
          </div>
        </anim-scroll>
      </div>
    </div>
    <strate-available :platforms="allPlateforms" />
    <strate-contact />
    <strate-footer />
    <custom-cursor v-if="!$device.isMobile" class="custom-cursor" :style="{'opacity': isVideoEnded ? 1 : 0}" />
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import StrateVideo from '@/components/StrateVideo'
import StrateVideo2 from '@/components/StrateVideo2'
import StrateKeypoints from '@/components/StrateKeypoints'
import StrateThemes from '@/components/StrateThemes'
import StrateThemesMobile from '@/components/StrateThemesMobile'
import StrateAvailable from '@/components/StrateAvailable'
import StrateContact from '@/components/StrateContact'
import StrateFooter from '@/components/StrateFooter'
import CustomCursor from '@/components/CustomCursor'

import AnimScroll from '@/components/common/AnimScroll'

import ExternalLink from '@/components/common/ExternalLink'

export default {
  name: 'Homepage',

  components: {
    AppHeader,
    StrateVideo,
    StrateKeypoints,
    StrateThemes,
    StrateVideo2,
    ExternalLink,
    StrateAvailable,
    StrateContact,
    StrateFooter,
    StrateThemesMobile,
    AnimScroll,
    CustomCursor
  },

  data () {
    let plateforms = []
    const allPlateforms = [
      {
        name: 'steam',
        url: 'https://store.steampowered.com/app/1282500/Prisme_7/'
      },
      {
        name: 'google',
        url: 'https://play.google.com/store/apps/details?id=com.CentrePompidou.Prisme7'
      },
      {
        name: 'app-store',
        url: 'https://apps.apple.com/fr/app/prisme-7/id1504092385'
      },
      {
        name: 'windows',
        url: '/download/'
      },
      {
        name: 'mac',
        url: 'https://apps.apple.com/us/app/prisme-7/id1504092385?l=fr&ls=1'
      }
    ]

    if (this.$device.isAndroid) {
      plateforms = [{
        name: 'google',
        url: 'https://play.google.com/store/apps/details?id=com.CentrePompidou.Prisme7'
      }]
    }
    else if (this.$device.isIpad || this.$device.isIphone) {
      plateforms = [{
        name: 'app-store',
        url: 'https://apps.apple.com/fr/app/prisme-7/id1504092385'
      }]
    }
    else {
      plateforms = [...allPlateforms]
    }
    return {
      platforms: plateforms,
      allPlateforms: allPlateforms,
      isVideoEnded: false
    }
  },
  mounted () {
    setTimeout(()=>{ this.isVideoEnded = true}, 5000)
  }
}

</script>

<style lang="stylus">
.custom-cursor
  transition opacity 1s
  opacity 0
</style>
